<template>
  <div>
    <material-button
      class="d-none show-modal-connect-existing-account"
      data-bs-toggle="modal"
      data-bs-target="#connectExistingAccount"
    ></material-button>
    <div id="custom-overlay" class="custom-modal-overlay"></div>
    <div
      class="modal fade"
      id="connectExistingAccount"
      tabindex="-1"
      aria-hidden="true"
      style="z-index: 1056"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Connect Existing Account
            </h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>
          <div class="modal-body" style="overflow-y: unset">
            <div class="group-option-list">
              <label class="fw-bold" for
                >Account ID <span class="text-danger ms-2">*</span></label
              >
              <material-input
                v-model="stripeUserId"
                type="text"
                id="stripe_user_id"
                name="stripe_user_id"
              />
              <div
                class="mt-3 text-danger"
                style="word-break: break-all"
                v-if="messageErr"
              >
                {{ messageErr }}
              </div>
            </div>
            <div class="d-flex justify-content-end mt-5">
              <material-button
                class="mx-2 btn btn-sm btn-background"
                @click="connectExistingAccount()"
              >
                Connect
              </material-button>
              <material-button
                class="mx-2 btn btn-sm btn-background btn-cancel"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </material-button>
            </div>
          </div>
        </div>
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>
<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import PaymentService from "@/services/payment.service";
import $ from "jquery";

export default {
  name: "connect-existing-account",
  components: {
    MaterialLoading,
    MaterialSnackbar,
    MaterialButton,
    MaterialInput,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
    physicalBranchId: {
      type: Number,
      required: true,
    },
    merchantId: {
      type: Number,
      required: true,
    },
    getList: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      snackbar: null,
      message: "",
      loaderActive: false,
      stripeUserId: "",
      messageErr: "",
    };
  },
  methods: {
    connectExistingAccount() {
      if (this.stripeUserId == "" || this.stripeUserId == null) {
        this.messageErr = "Account ID is required";
        return;
      }

      this.showLoader();
      let dataForm = {
        type: this.type,
        physical_branch_id: this.physicalBranchId,
        merchant_id: this.merchantId,
        account_id: this.stripeUserId,
      };

      PaymentService.connectExistingAccount(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            $(".btn-cancel").click();
            this.snackbar = "success";
            this.message = "Connect Successfully!";
            this.setTimeOutNotification();
            this.getList(1);
          } else {
            this.messageErr = response.data.result.message;
          }
          this.hideLoader();
        },
        (error) => {
          this.messageErr = error.response.data.result.message;
          this.hideLoader();
        }
      );
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
  watch: {
    keyReload() {
      this.stripeUserId = "";
      this.messageErr = "";
    },
  },
};
</script>
